class LangSelector extends HHBaseElement {
  constructor() {
    super();

    this.submitButton = this.querySelector(".js-submit-localization")
    this.countrySelector = this.querySelector(".js-country-selector")
    this.languageSelector = this.querySelector(".js-language-selector")
    this.form = this.querySelector("form")
    this.langHiddenInput = this.querySelector(".js-lang")

    this.submitButton.addEventListener("click", this.submit.bind(this))
    document.addEventListener('countryChanged', this.toggleLangSelector.bind(this))
    this.toggleLangSelector()
  }

  connectedCallback() {
    this._setupFocusTrap(this.closest('slide-panel'))
  }

  onItemClick(event) {
    event.preventDefault();
    const lang = this.querySelector(".js-lang")
    const form = this.querySelector('form');
    lang.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }

  toggleLangSelector() {
    const countryOption = this.countrySelector.querySelector('[aria-selected="true"]');
    const country = countryOption?.innerText;
    const languages = (countryOption?.dataset?.languages || 'en').split(',');
    this.languageSelector.querySelectorAll('[role="option"]').forEach(option => {
      const langValue = option.dataset.value.toLowerCase();
      if (languages.includes(langValue)) {
        option.classList.remove("hidden");
      } else {
        option.classList.add("hidden");
      }
    });
    this.languageSelector.querySelector('[role="option"]:not(.hidden)')?.click();
    if (country === "US" || country === "United States") {
      this.languageSelector.classList.add("hidden")
    } else {
      this.languageSelector.classList.remove("hidden")
    }
  }

  submit() {
    const countryUrl = this.countrySelector.querySelector('[aria-selected="true"]')?.dataset?.href
    const lang = this.form.querySelector('[aria-selected="true"]')?.dataset.value || 'en'

    window.location.href = `${countryUrl.replace('en-', `${lang}-`)}`;
  }
}

window.customElements.define('lang-selector', LangSelector);
